import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateProjectFooterWrapper = styled.div`
  margin: 16px 0px;
  background-color: ${COLORS.cirrus_white};
  padding: 32px 16px 20px;
  display: flex;
  justify-content: space-between;

  ${responsive.MOBILE`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 8px 0 8px;
    margin: 16px 0px;
    
    & > div:last-child {
      order: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
      
      button:last-child {
        order: 1;
      }
      
      button:first-child {
        order: 2;
      }
    }
    
    .back-button {
      order: 3;
      width: 100%;
    }
    
    .btn-secondary, 
    .btn-primary,
    .btn-tertiary {
      width: 100%;
      margin: 0;
      justify-content: center;
    }
  `}

  .btn-secondary {
    margin-right: 16px;
  }
`;
